$(document).ready(function(){
    if($('.info-banner').length){
        $('body').addClass('is-banner');
    }
    else {
        if ($('body').hasClass('is-banner')){
            $('body').removeClass('is-banner');
        }
    }
});